import { useMemo } from 'react'

import { BoxProps, Grid } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'
import { SpotlightContentExpertSession } from 'interfaces/types'

import { ExpertCard } from './expertCard'
import useStyles from './index.styles'
import { CarouselOrListingBlockWrapper } from '../carouselOrListingBlockWrapper'
import SectionWrapper from '../sectionWrapper'

type Props = {
  applyH1?: boolean
  wrapperPropsStyles?: BoxProps
} & SpotlightContentExpertSession &
  BoxProps

export const ContentExpert = (props: Props) => {
  const {
    doctors,
    styles,
    className,
    classNames,
    wrapperProps,
    wrapperPropsStyles,
    applyH1,
  } = props
  const { classes, cx, theme } = useStyles(undefined, {
    name: 'ContentExpert',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  const listLength = useMemo(() => doctors.length, [doctors])
  const perSlide = useMemo(() => (isMobile ? 4 : 1), [isMobile])
  const slideGroup = useMemo(
    () =>
      new Array(Math.ceil(listLength / perSlide))
        .fill('')
        .map((_i, idx) =>
          doctors.slice(idx * perSlide, idx * perSlide + perSlide),
        ),
    [isMobile],
  )
  return (
    <SectionWrapper
      className={cx(className, classes.root)}
      defaultColor={theme.fn.primaryColor()}
      applyH1={applyH1}
      {...wrapperProps}
      {...wrapperPropsStyles}
    >
      <CarouselOrListingBlockWrapper
        lengthToCarouselDesktop={4}
        showFullSlide={!isMobile}
        percentOfEndSlideMobile={85}
        carouselSetting={{
          withIndicators: false,
        }}
      >
        <CarouselOrListingBlockWrapper.Slider
          styles={(theme) => ({
            listing: {
              [theme.fn.largerThan('sm')]: {
                '.mantine-Grid-root': {
                  margin: 0,
                },
                '.mantine-Grid-col': {
                  padding: 0,
                },
              },
            },
            sliderWrapper: {
              [theme.fn.largerThan('sm')]: {
                '.mantine-Grid-root': {
                  margin: 0,
                },
                '.mantine-Grid-col': {
                  padding: 0,
                },
              },
            },
          })}
        >
          {slideGroup.map((doctor, doctorIdx) => (
            <Grid
              justify={
                slideGroup.length === 1 && doctor.length === 1
                  ? 'center'
                  : undefined
              }
              grow={slideGroup.length > 1 && doctor.length > 1}
              gutterMd={24}
              gutterXs={16}
              key={doctorIdx}
              sx={{
                [theme.fn.smallerThan('sm')]: {
                  height: 'auto !important',
                },
              }}
            >
              {doctor.map((i, idx) => (
                <Grid.Col
                  span={
                    !isMobile && slideGroup.length === 1 && doctor.length === 1
                      ? 6
                      : 12
                  }
                  key={idx}
                >
                  <ExpertCard
                    size={!isMobile && slideGroup.length < 3 ? 'lg' : 'md'}
                    className={classes.card}
                    key={idx}
                    {...i}
                  />
                </Grid.Col>
              ))}
            </Grid>
          ))}
        </CarouselOrListingBlockWrapper.Slider>
      </CarouselOrListingBlockWrapper>
    </SectionWrapper>
  )
}
